import React from 'react';
import styled from 'styled-components';

export const Call = () => {
  return (
    <Container>
        <h1>Za naručivanje/rezervaciju pozovite: <br/><a href="tel:+381649212201"><span>064/9212201</span></a><br/><a href="tel:+381643523592"><span>064/3523592</span></a></h1>
    </Container>
  )
}

const Container = styled.div`
    margin-top: 1rem;

    h1{
        text-align: center;
        font-size: 1rem;
        color: #fff;

        a{
          text-decoration: none;
          cursor: default;
        }

        span{
            font-family: "Roboto", sans-serif;
            font-size: 1.5rem;
            color: #cbb16d;
        }
    }
`;
